import './qlQuestionBox.css'
import parse from 'html-react-parser';
import axios from 'axios';
import { API_ENDPOINT, HEADER_TOKEN } from '../../constants/constants';
import { useState } from 'react';
import EditModal from '../widgets/ratulModal/editModal';
import { cleanO } from '../../utils/util';

const KEYS = ['A', 'B', 'C', 'D', 'E', 'F']

const QlQuestionBox = (props) => {
    const { q, i, showAns, onDelete, onEdited } = props
    const [s, setS] = useState(q.status)
    const [showModal, setShowModal] = useState(false)

    const setStatus = (e) => {
        e.stopPropagation()
        let toupdate = s === "Active" ? "Inactive" : "Active"
        axios.post(API_ENDPOINT + 'sam/set-question-status', { id: q._id, status: toupdate }, HEADER_TOKEN).then(res => {
            if (res.data.success) setS(toupdate)
        })
    }

    return (
        <div style={{ border: '1px solid var(--color-divider)', padding: 14 }}>
            <EditModal toEditQ={q} onEdited={onEdited} showModal={showModal} setShowModal={setShowModal} />

            <div style={{ display: 'flex', alignItems: 'flex-start', gap: 8, marginBottom: 10 }}>
                <div style={{ flex: 1, fontWeight: 600, fontSize: 14 }}>
                    <span style={{ fontFamily: 'var(--font-heading)', fontWeight: 800 }}>Q{i + 1}.</span> {parse(cleanO(q.question))}
                </div>
                <div style={{ display: 'flex', alignItems: 'center', gap: 2, flex: 'none' }}>
                    <button className="btn btn-ghost" onClick={() => setShowModal(!showModal)} aria-label="Edit" style={{ padding: 4 }}>
                        <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M12 20h9" /><path d="M16.5 3.5a2.12 2.12 0 0 1 3 3L7 19l-4 1 1-4Z" /></svg>
                    </button>
                    <button className="btn btn-ghost" onClick={onDelete} aria-label="Delete" style={{ padding: 4 }}>
                        <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M3 6h18" /><path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6" /><path d="M8 6V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2" /></svg>
                    </button>
                    <span onClick={setStatus} className={s === 'Active' ? 'tag tag-accent' : 'tag tag-neutral'} style={{ cursor: 'pointer' }} title="Toggle status">{s}</span>
                </div>
            </div>

            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 8 }}>
                {q.options.map((o, oi) => {
                    const correct = showAns && o.isCorrect
                    return (
                        <div key={oi} style={{
                            display: 'flex', alignItems: 'center', gap: 8, padding: '7px 10px', fontSize: 13,
                            border: `1px solid ${correct ? 'var(--color-accent)' : 'var(--color-divider)'}`,
                            background: correct ? 'var(--color-accent-100)' : 'transparent',
                            color: correct ? 'var(--color-accent-800)' : 'var(--color-text)',
                        }}>
                            <span style={{ fontFamily: 'var(--font-heading)', fontWeight: 800, fontSize: 12 }}>{KEYS[oi]}</span>
                            {parse(cleanO(o.option))}
                        </div>
                    )
                })}
            </div>

            {showAns && q.topic ? (
                <div style={{ marginTop: 10, fontSize: 11 }} className="text-muted">Topic: {q.topic}</div>
            ) : null}
        </div>
    )
}
export default QlQuestionBox
